import XTbl,{Xtc} from '../../../../components/x-table';
const tbl = new XTbl('/matter/query/removed/', 'recovery');

tbl.add(new Xtc('title', 'Title'))
tbl.add(new Xtc('client.id', 'Client').renderSlot('client'))
tbl.add(new Xtc('status', 'status').renderSlot('status'))
tbl.add(new Xtc('practice_area.title', 'Practice Area'))
tbl.add(new Xtc('group.title', 'group'))
tbl.add(new Xtc('open_date', 'Open date'))
tbl.add(new Xtc('closed_date', 'closed date'))
tbl.add(new Xtc('pending_date', 'pending date').hidden())
tbl.add(new Xtc('limitation_date', 'limitation date').hidden())
tbl.add(new Xtc('reference_code', 'Reference Number'))
tbl.add(new Xtc('responsible.id', 'Responsible').renderSlot('responsible').hidden())
tbl.add(new Xtc('origination.id', 'Origination').renderSlot('origination').hidden())
tbl.add(new Xtc('location', 'location'))
tbl.add(new Xtc('created_at', 'created at').hidden())
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

